import { trackPageLoad } from "@asosteam/asos-content-web-analytics";
import sdkProvider from "./sdk-provider";
import analyticsProvider from "../analyticsProvider";
import getUserLoginStatus from "./getUserLoginStatus";
export const trackPageEvent = async (pageNumber, ctaRef) => {
    try {
        const identity = await sdkProvider("identity");
        const customerId = await identity.customer.customerId();
        const isAuthenticated = await identity.customer.isAuthenticated();
        const isRecognised = (await identity.customer.isRecognised?.()) || false;
        const { platform = "", storeId = "", floor = "", } = window.asos.webContext.getWebContext();
        const server = `${platform} ${storeId.toLowerCase()}`;
        const pageLoadProperties = {
            server,
            customerId,
            loginStatus: getUserLoginStatus({ isAuthenticated, isRecognised }),
            pageName: "ugc view gallery",
            floor,
            conditionalProps: {},
        };
        if (pageNumber > 0) {
            pageLoadProperties.pageNumber = pageNumber + 1;
        }
        if (ctaRef) {
            pageLoadProperties.conditionalProps.prop6 = `${ctaRef} ugc view gallery`;
        }
        const config = analyticsProvider("ugc-page-load", pageLoadProperties);
        await trackPageLoad(config);
    }
    catch (e) {
        throw new Error(e);
    }
};
